import { RJSFSchema } from '@rjsf/utils';

import { ROLE_ADMIN_USER, ROLE_HOTEL_COORDINATOR, ROLE_ROLE_ADMIN, ROLE_VENDOR_USER } from '~/consts/roles';

export function isVendorUserCreationOnly(user: { roles?: Array<string> } | null | undefined) {
  return Boolean(
    user?.roles?.includes(ROLE_HOTEL_COORDINATOR) &&
    !user.roles.includes(ROLE_ADMIN_USER) &&
    !user.roles.includes(ROLE_ROLE_ADMIN),
  );
}

// UI guidance only: svc-auth independently enforces the role and vendor boundary.
export function vendorUserCreationSchema(schema: RJSFSchema): RJSFSchema {
  const properties = { ...schema.properties };
  delete properties.email_verified;
  delete properties.bypass_confirmation_email;
  const roles = properties.roles as RJSFSchema;
  const vendors = properties.vendors as RJSFSchema;
  return {
    ...schema,
    required: [...new Set([...(schema.required ?? []), 'roles', 'vendors'])],
    properties: {
      ...properties,
      roles: {
        ...roles,
        minItems: 1,
        maxItems: 1,
        default: [ROLE_VENDOR_USER],
        items: { type: 'string', enum: [ROLE_VENDOR_USER] },
      },
      vendors: { ...vendors, minItems: 1 },
    },
  };
}
